import React from "react";
import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Box from "@cloudscape-design/components/box";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { playerRulesAutomaticLogStore } from "../stores/playerRulesAutomaticLog";
import Button from "@cloudscape-design/components/button";
import { userStore } from "../stores/access";
/* ------- */

class PlayerRulesAutomaticLog extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.Interface.loadPlayerRulesAutomaticLog();
	}

	render() {

		return (
			<>
				{this.props.playerRulesAutomaticLog.loaded && this.props.playerRulesAutomaticLog.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.playerRulesAutomaticLog.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.playerRulesAutomaticLog.error.code} | request timestamp: {this.props.playerRulesAutomaticLog.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}


				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.playerRulesAutomaticLog.loaded}
					sortingColumn={{ sortingField: this.props.playerRulesAutomaticLog.sorting.sortingColumn.column }}
					sortingDescending={this.props.playerRulesAutomaticLog.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setPlayerRulesAutomaticLogStore({
							...this.props.playerRulesAutomaticLog,
							sorting: {
								...this.props.playerRulesAutomaticLog.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField,
								},
								isDescending: sorting.detail.isDescending,
							},
						});
						setTimeout(() => {
							this.props.Interface.loadProvider();
						}, 250);
					}}
					columnDefinitions={[
						{
							id: "uid",
							header: "UID",
							sortingField: "uid",
							cell: (item) => (
								<Button
									iconName={
										typeof item.verify !== "undefined" && item.verify.status === 3
											? "status-stopped"
											: typeof item.verify !== "undefined" && item.verify.verified
												? "status-positive"
												: "status-in-progress"
									}
									className={this.props.styles?.["btnUID"]}
									variant="normal"
									onClick={() => {
										this.props.Interface.loadInfo(item.uid, item.brand);
									}}
									children={item.uid}
								/>
							),
						},
						{ id: "name", header: "Name", sortingField: "name", cell: (item) => item.name },
						{
							id: "brand", header: "Brand", sortingField: "brand", cell: (item) => <img
								className={this.props.styles?.["withdrawalsBrand"]}
								src={
									document.body.classList[0] === "awsui-dark-mode"
										? this.props.user.brandsList[item.brand - 1].logoDark
										: this.props.user.brandsList[item.brand - 1].logo
								}
								alt="brand"
							/>,
						},
						{
							id: "description",
							header: "Description",
							sortingField: "description",
							cell: (item) => item.description,
						},
						{
							id: "createdAt",
							header: "Date",
							sortingField: "createdAt",
							cell: (item) => (
								<>
									{new Date(item.createdAt).toLocaleDateString() +
										" " +
										new Date(item.createdAt).toLocaleTimeString()}
								</>
							),
						},
					]}
					items={this.props.playerRulesAutomaticLog.data}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Automatic log per page", options: this.props.config.playerRulesAutomaticLog.preferences.perPage }}
							preferences={{ pageSize: this.props.config.playerRulesAutomaticLog.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("playerRulesAutomaticLog.perPage", preferences.detail.pageSize);
								this.props.setConfig({
									...this.props.config,
									playerRulesAutomaticLog: { ...this.props.config.playerRulesAutomaticLog, perPage: preferences.detail.pageSize },
								});
								setTimeout(() => {
									this.props.Interface.loadProvider();
								}, 250);
							}}
						/>
					}
					pagination={
						<Pagination
							disabled={!this.props.playerRulesAutomaticLog.loaded}
							currentPageIndex={this.props.playerRulesAutomaticLog.pagination.current}
							pagesCount={this.props.playerRulesAutomaticLog.pagination.total}
							onChange={(page) => {
								this.props.setPlayerRulesAutomaticLogStore({
									...this.props.playerRulesAutomaticLog,
									pagination: { ...this.props.playerRulesAutomaticLog.pagination, current: page.detail.currentPageIndex },
								});
								setTimeout(() => {
									this.props.Interface.loadProvider();
								}, 250);
							}}
						/>
					}
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="Automatic log"
									counter={<>({this.props.playerRulesAutomaticLog.pagination.count})</>}
								/>
							}
						/>
					}
					empty="No automatic log found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const playerRulesAutomaticLog = useRecoilValue(playerRulesAutomaticLogStore);
		const setPlayerRulesAutomaticLogStore = useSetRecoilState(playerRulesAutomaticLogStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const user = useRecoilValue(userStore);

		return (
			<Component
				{...props}
				user={user}
				playerRulesAutomaticLog={playerRulesAutomaticLog}
				setPlayerRulesAutomaticLogStore={setPlayerRulesAutomaticLogStore}
				config={config}
				setConfig={setConfig}
			/>
		);
	};
}

export default withRecoil(PlayerRulesAutomaticLog);
